<template>
  <span class="ca-header__title caption-medium">
    <slot />
  </span>
</template>

<style scoped lang="scss">
.ca-header__title {
  color: var(--ca-color-text-primary);
  text-align: center;
  letter-spacing: var(--letter-spacing-xs);
}
</style>
